import { Component, ElementRef, OnInit } from "@angular/core";
import { filter, merge, of, Subscription, takeUntil, take } from "rxjs";
import { DestroyableMixin } from "apps-module/app/shared-library/mixins/destroyable.mixin";
import { LockMixin } from "apps-module/app/shared-library/mixins/lock.mixin";
import { ConfigurationService } from "apps-module/app/shared-library/services/configuration/configuration.service";
import { BrowserWindowService } from "apps-module/app/shared-library/services/environment/browser-window.service";
import { EmptyInstance } from "core-library/mixins/empty-instance";
import { SearchConfigurationModel } from "apps-module/app/entry-modules/assistants-profile-search/models/search-configuration.model";
import { FormSearchParametersService } from "apps-module/app/entry-modules/assistants-profile-search/services/form-search-parameters.service";
import { SearchService } from "apps-module/app/entry-modules/assistants-profile-search/services/search.service";
import { QuerySearchParametersService } from "apps-module/app/entry-modules/assistants-profile-search/services/query-search-parameters.service";
import { SearchForm } from "apps-module/app/entry-modules/assistants-profile-search/forms/search.form";
import { FormSearchParametersModel } from "apps-module/app/entry-modules/assistants-profile-search/models/form-search-parameters.model";
import { SearchResultItemModel } from "apps-module/app/entry-modules/assistants-profile-search/models/search-result-item.model";
import { Pending } from "apps-module/app/shared-library/decorators/pending.decorator";
import { SearchResultModel } from "apps-module/app/entry-modules/assistants-profile-search/models/search-result.model";
import { SearchStatus } from "apps-module/app/shared-library/enums/search-status.enum";

@Component({
    selector: AssistantsProfileSearchComponent.SELECTOR,
    templateUrl: "./assistants-profile-search.component.html",
    providers: [ConfigurationService, FormSearchParametersService, SearchService, QuerySearchParametersService]
})
export class AssistantsProfileSearchComponent extends DestroyableMixin(LockMixin(EmptyInstance)) implements OnInit {

    public static SELECTOR: string = "[pcg-ng-assistants-profile-search]";

    // TODO: is this decorator necessary?
    @Pending
    private _onSearch: Subscription;

    public configuration: SearchConfigurationModel;
    public searchForm: SearchForm;
    public results: Array<SearchResultItemModel> = [];
    public totalPages: number = 1;
    public totalCount: number = 0;
    public searchStatus: SearchStatus = SearchStatus.Loading;
    public statuses = SearchStatus;

    public constructor(
        private _domElement: ElementRef,
        private _browserWindowService: BrowserWindowService,
        private _configurationService: ConfigurationService<SearchConfigurationModel>,
        private _searchParametersFactory: FormSearchParametersService,
        private _searchService: SearchService,
        private _queryStringSetterService: QuerySearchParametersService
    ) { super(); }

    public ngOnInit(): void {
        this._configurationService.initialize(this._domElement);

        this.configuration = this._configurationService.getConfiguration();

        const queryString = this._browserWindowService.getQueryString();
        const searchParameters = this._searchParametersFactory.create(queryString, this.configuration);
        this.searchForm = SearchForm.createForm(searchParameters);

        merge(of(searchParameters), this.searchForm.onFormSubmitted)
            .pipe(
                filter(() => !this.isLocked),
                takeUntil(this.onDestroy)
            )
            .subscribe(searchParams => this.invokeSearch(searchParams));
    }

    private invokeSearch(formSearchParameters: FormSearchParametersModel): void {
        this.searchStatus = SearchStatus.Loading;
        this._queryStringSetterService.set(formSearchParameters);

        this._onSearch = this._searchService.search(formSearchParameters)
            .pipe(take(1))
            .subscribe({
                next: (response: SearchResultModel) => {
                    const searchResult = {...response.results};

                    this.totalCount = searchResult.totalItems ?? 0;
                    this.totalPages = searchResult.totalPages ?? 1;
                    this.results = [...searchResult.pageItems];
                    this.searchStatus = SearchStatus.Success;
                },
                error: () => this.searchStatus = SearchStatus.Error
            });
    }
}
